import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { VisitorSourceType } from '@/api';
import { sourceLabel } from '../../../visitorStatus';

const SystemSourceField = forwardRef((props, ref) => {
  const { data: initial } = props;
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    fillValue: data => {
      data.status = data.status || [];
      data.status['source'] = inputRef.current.value;
      return true;
    },
  }));

  return (
    <TextField
      select
      name={'source'}
      label={'Источник'}
      inputRef={inputRef}
      fullWidth
      margin='dense'
      variant='outlined'
      autoComplete='off'
      defaultValue={(initial.status && initial.status['source']) || VisitorSourceType.Manual}
    >
      {Object.values(VisitorSourceType).map(v => (
        <MenuItem key={v} value={v}>
          {sourceLabel(v)}
        </MenuItem>
      ))}
    </TextField>
  );
});

export default SystemSourceField;
